<template>
  <div class="tab-block" v-if="!isShare">
    <div class="tab-listtab" :class="hasSelectedGame ? 'shequBg' : 'otherBg'">
      <div
        v-for="(item, index) in filteredTabList"
        :key="index"
        :class="[
          'list-item',
          { active: currentPath === item.link },
          { 'community-game-active': currentPath === item.link && item.link === '/pages/community/community' && hasSelectedGame }
        ]"
        @click="switchTab(item.link, item)"
      >
        <div class="item-img-box">
          <img
            v-if="currentPath !== item.link"
            class="item-img"
            :src="item.icon"
            alt=""
          />
          <img
            v-else
            :class="item.link === '/pages/community/community' && hasSelectedGame ? 'community-img' : 'item-img'"
            :src="item.bg_icon"
            alt=""
          />
          <div v-if="item.link === '/pages/member/member'" class="new">up</div>
        </div>

        <div
          v-if="currentPath === item.link && item.link !== '/pages/community/community'"
          class="item-text activeColor"
        >
          {{ item.title }}
        </div>
        <div
          v-if="currentPath === item.link && item.link === '/pages/community/community' && !hasSelectedGame"
          class="item-text activeColor"
        >
          {{ item.title }}
        </div>

        <img
          v-if="item.link === '/pages/community/community' && currentPath === '/pages/community/community' && hasSelectedGame"
          class="change-icon"
          src="@/assets/image/tabbar/Vector.svg"
          alt=""
          @click.stop="handleChangeIcon"
        />
      </div>
      <!-- 社区首次没有添加游戏 / 切换游戏引导气泡 -->
      <div class="bubble-pop" v-if="showCommunityBubble">
        <div class="bubble-pop-title">点击此处切换游戏</div>
        <img
          class="bubble-pop-close"
          src="@/assets/image/icon/closeTip.svg"
          alt=""
          @click="handleCloseBubble"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Tabbar',
  props: {
    showCommunitySwitchGuide: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentPath: '/pages/index/index',
      isFirstCommunityVisit: true,
      tabList: [{
        link: '/pages/index/index',
        title: '游戏',
        icon: require('@/assets/image/tabbar/home.svg'),
        bg_icon: require('@/assets/image/tabbar/home-active.svg'),
        yunFlag: true
      }, {
        link: '/pages/yun/yun',
        title: '云手机',
        icon: require('@/assets/image/tabbar/yun-active.svg'),
        bg_icon: require('@/assets/image/tabbar/yun.svg'),
        yunFlag: true
      }, {
        link: '/pages/member/member',
        title: '会员',
        icon: require('@/assets/image/tabbar/member.svg'),
        bg_icon: require('@/assets/image/tabbar/member-active.svg'),
        yunFlag: true
      }, {
        link: '/pages/user/user',
        title: '我的',
        icon: require('@/assets/image/tabbar/user.svg'),
        bg_icon: require('@/assets/image/tabbar/user-active.svg'),
        yunFlag: true
      }, {
        link: '/pages/community/community',
        title: '福利',
        icon: require('@/assets/image/tabbar/shequ.svg'),
        bg_icon: require('@/assets/image/tabbar/shequ-active.svg'),
        yunFlag: true
      }],
    }
  },
  computed: {
    ...mapState({
      selectedCommunityGame: state => state.user.selectedCommunityGame
    }),
    isShare() {
      return this.$route.query.share_type
    },
    filteredTabList() {
      return this.tabList.filter(item => item.yunFlag)
    },
    hasSelectedGame() {
      const game = this.selectedCommunityGame
      return !!(game && (game.game_id || game.id))
    },
    // 与 uni-new39 view-tabbar 一致：社区页首次未选游戏，或社区切换引导时显示气泡
    showCommunityBubble() {
      if (this.currentPath !== '/pages/community/community' || !this.isFirstCommunityVisit) return false
      if (this.showCommunitySwitchGuide) return true
      return !this.hasSelectedGame
    },
  },
  watch: {
    '$route.path': {
      handler(newPath) {
        this.currentPath = newPath
      },
      immediate: true
    },
    selectedCommunityGame: {
      handler() {
        this.applySelectedCommunityGameIcon()
      },
      immediate: true
    }
  },
  mounted() {
    this.currentPath = this.$route.path
    this.$ajax('/recharge/rechargeConfig').then(rs => {
      if (rs.code == 200) {
        this.tabList.forEach(item => {
          if (item.link == '/pages/yun/yun') {
            item.yunFlag = rs.data.yunFlag
          }
        })
      }
    })
  },
  methods: {
    getDefaultCommunityTabIcon() {
      return {
        icon: require('@/assets/image/tabbar/shequ.svg'),
        bg_icon: require('@/assets/image/tabbar/shequ-active.svg'),
      }
    },
    applySelectedCommunityGameIcon() {
      const game = this.selectedCommunityGame
      const hasGame = game && (game.game_id || game.id) && game.icon
      const communityIcon = hasGame
        ? { icon: game.icon, bg_icon: game.icon }
        : this.getDefaultCommunityTabIcon()
      this.tabList = this.tabList.map(item => {
        if (item.link !== '/pages/community/community') return item
        return {
          ...item,
          ...communityIcon
        }
      })
    },
    openPlayingGamePopup(navigateToCommunity = false) {
      const payload = {
        show: true,
        navigateToCommunity: Boolean(navigateToCommunity)
      }
      // 先重置再打开，确保重复点击也能触发弹窗
      this.$store.commit('popup/setPlayingGamePopup', {
        show: false,
        navigateToCommunity: payload.navigateToCommunity
      })
      this.$nextTick(() => {
        this.$store.commit('popup/setPlayingGamePopup', payload)
        this.$root.$emit('open-playing-game-popup')
      })
    },
    handleChangeIcon() {
      this.$emit('changeIcon')
      this.openPlayingGamePopup(false)
    },
    handleCloseBubble() {
      this.isFirstCommunityVisit = false
    },
    hasSelectedCommunityGame() {
      return this.hasSelectedGame
    },
    switchTab(path, item) {
      // 未选择社区游戏时，点击福利先打开在玩游戏弹窗（与 uni-new39 一致）
      if (path === '/pages/community/community' && !this.hasSelectedGame) {
        this.openPlayingGamePopup(true)
        return
      }

      // 已在社区且已选游戏时，点击福利打开切换游戏弹窗
      if (
        path === '/pages/community/community' &&
        this.currentPath === '/pages/community/community' &&
        this.hasSelectedGame
      ) {
        this.handleChangeIcon()
        return
      }

      if (this.currentPath === path) return

      // 检查是否需要登录权限的路径
      if (path === '/pages/user/user' || path === '/pages/member/member' || path === '/pages/yun/yun') {
        const isLoggedIn = this.$store.getters.logged
        if (!isLoggedIn) {
          this.$store.commit('popup/setloginpop', true)
          return
        }
      }

      this.currentPath = path
      this.$router.push(path)
    }
  }
}
</script>

<style lang="scss" scoped>
.tab-block {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 55;
  width: 100%;
  max-width: 523px;
  right: 0;
  margin: 0 auto;
}

.tab-listtab {
  display: flex;
  align-items: center;
  justify-content: space-around;
  box-sizing: border-box;
  height: calc(3.15rem + env(safe-area-inset-bottom));
  height: calc(3.15rem + constant(safe-area-inset-bottom));
  padding: 0.625rem 0.85rem;
  padding-bottom: calc(0.625rem + env(safe-area-inset-bottom));
  padding-bottom: calc(0.625rem + constant(safe-area-inset-bottom));
  list-style: none;
  box-shadow: 0 -0.05rem 0.05rem 0.05rem rgba(0, 0, 0, 0.04);
  position: relative;
}

.otherBg {
  background-color: rgba(0, 0, 0, 0.8);
  -webkit-backdrop-filter: blur(0.875rem);
  backdrop-filter: blur(0.875rem);
}

.shequBg {
  background-color: rgba(0, 0, 0, 0.85);
  -webkit-backdrop-filter: blur(0.875rem);
  backdrop-filter: blur(0.875rem);
}

.list-item {
  flex: 0 0 3.2rem;
  height: 1.9rem;
  min-width: 0;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  .item-img-box {
    position: relative;
    display: flex;
    flex: 0 0 auto;
    align-items: center;
    line-height: 0;

    .item-img {
      display: block;
      width: 1.2rem;
      height: 1.2rem;
    }

    .community-img {
      display: block;
      width: 1.65rem;
      height: 1.65rem;
      border-radius: 50%;
      object-fit: cover;
    }
  }

  .item-text {
    margin-left: 0.35rem;
    font-size: 0.6rem;
    font-weight: 400;
    line-height: 0.7rem;
    white-space: nowrap;
  }
}

.active {
  flex-basis: 4.2rem;
  justify-content: flex-start;
  padding: 0 0.95rem 0 0.5rem;
  background: rgba(51, 53, 57, 0.7);
  border-radius: 1rem;

  &.community-game-active {
    padding: 0 0.25rem;
    background-color: rgba(51, 53, 57, 1) !important;
    -webkit-backdrop-filter: blur(0.15rem) !important;
    backdrop-filter: blur(0.15rem) !important;
  }
}

.activeColor {
  font-size: 0.6rem;
  color: #FFDB89;
}

.new {
  position: absolute;
  left: 0.6rem;
  top: -0.1rem;
  width: 0.7rem;
  height: 0.45rem;
  border-radius: 0.225rem;
  background: #f04848;
  color: #fff;
  font-size: 0.3rem;
  line-height: 0.45rem;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
}

.change-icon {
  display: block;
  flex: 0 0 1rem;
  align-self: center;
  width: 1rem;
  height: 1rem;
  margin-left: 0.5rem;
}

.bubble-pop {
  width: 7.8rem;
  height: 1.9rem;
  background: rgba(51, 53, 57, 0.9);
  border-radius: 0.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0.8rem;
  top: -1.625rem;
  z-index: 2;

  &::after {
    content: '';
    position: absolute;
    right: 2rem;
    bottom: -0.4rem;
    width: 0;
    height: 0;
    border-left: 0.4rem solid transparent;
    border-right: 0.4rem solid transparent;
    border-top: 0.4rem solid rgba(51, 53, 57, 0.9);
  }

  .bubble-pop-title {
    font-size: 0.7rem;
    color: #ffffff;
  }

  .bubble-pop-close {
    width: 0.7rem;
    height: 0.7rem;
    margin-left: 0.45rem;
    cursor: pointer;
  }
}
</style>
